/**
 * HataSayfasi
 *
 * 401/403/404/500 ve demo süresi doldu ekranlarının ortak gövdesi. Giriş
 * sayfasıyla aynı iskeleti (OturumDisiSayfa) kullanır: solda marka paneli,
 * sağda durum. Yeni bir durum sayfası eklerken bu bileşeni kullan, sıfırdan
 * yazma.
 *
 * Props:
 *   kod       – "404" gibi büyük punto kod (opsiyonel)
 *   ikon      – React node (components/Ikonlar.js içindeki çizgi ikonlardan)
 *   renk      – 'violet' | 'amber' | 'rose' | 'indigo'
 *   baslik    – başlık
 *   aciklama  – açıklama metni (node olabilir)
 *   altYazi   – sol paneldeki açıklama
 *   children  – butonların üstünde ek içerik (iletişim kutusu gibi)
 *   aksiyonlar– butonlar
 */

import OturumDisiSayfa from '../../components/OturumDisiSayfa';

const RENKLER = {
  violet: { kutu: 'bg-violet-50 border-violet-100 text-violet-500', kod: 'text-violet-500/15' },
  amber:  { kutu: 'bg-amber-50 border-amber-100 text-amber-500',    kod: 'text-amber-500/15' },
  rose:   { kutu: 'bg-rose-50 border-rose-100 text-rose-500',       kod: 'text-rose-500/15' },
  indigo: { kutu: 'bg-indigo-50 border-indigo-100 text-indigo-500', kod: 'text-indigo-500/15' },
};

export default function HataSayfasi({
  kod, ikon, renk = 'violet', baslik, aciklama, altYazi, children, aksiyonlar,
}) {
  const t = RENKLER[renk] || RENKLER.violet;

  return (
    <OturumDisiSayfa dar altYazi={altYazi} baslik={'Bir şeyler\nters gitti.'}>
      <div className={`w-20 h-20 mx-auto rounded-3xl border-2 flex items-center justify-center ${t.kutu}`}>
        {ikon}
      </div>

      {kod && (
        <p className={`text-[88px] font-black leading-none select-none mt-4 -mb-3 ${t.kod}`}>{kod}</p>
      )}

      <h1 className="text-2xl font-black text-gray-800 tracking-tight mt-6">{baslik}</h1>
      <p className="text-gray-400 text-sm font-semibold leading-relaxed mt-3">{aciklama}</p>

      {children}

      {aksiyonlar && <div className="flex flex-wrap gap-3 justify-center mt-8">{aksiyonlar}</div>}
    </OturumDisiSayfa>
  );
}

/** Hata sayfalarındaki butonlar — ikisi de aynı ölçüde. */
export function HataButon({ birincil = false, children, ...props }) {
  return (
    <button
      {...props}
      className={birincil
        ? 'px-6 py-3.5 rounded-2xl bg-gradient-to-r from-violet-600 to-indigo-700 text-white ' +
          'text-[10px] font-black uppercase tracking-widest shadow-xl shadow-violet-200 ' +
          'hover:-translate-y-0.5 active:translate-y-0 transition-all'
        : 'px-6 py-3.5 rounded-2xl bg-white border-2 border-gray-100 text-gray-400 ' +
          'text-[10px] font-black uppercase tracking-widest hover:bg-gray-50 hover:text-gray-600 transition-all'}
    >
      {children}
    </button>
  );
}
